<div class="flexdiv">
  <button
    mat-icon-button
    (click)="selectEntityItemDiag()"
    style="margin-left: 10px"
  >
    <mat-icon>search</mat-icon>
  </button>
</div>
